import { useSystemThemeMode } from "@hooks/use-system-theme-mode";
import { appStateSelector } from "@store/app/app-selector";
import { userSettingsSelector } from "@store/settings/settings-selector";
import { useAppSelector } from "@store/store-helper";
/**
 * The colour-scheme mode the app should be in, `"system"` included.
 *
 * This is the value MUI's `setMode` takes, so handing it over unresolved lets MUI track the OS
 * query itself instead of the app resolving it and MUI resolving it again.
 *
 * Resolution order:
 * 1. Dark mode is a beta feature: when beta testing is disabled, always light.
 * 2. Otherwise the user's fetched `theme_mode` setting, which defaults to "system".
 */
export function useEffectiveColorSchemeMode() {
  const {
    isBetaTestingEnabled
  } = useAppSelector(appStateSelector);
  const {
    theme_mode: themeModeSetting
  } = useAppSelector(userSettingsSelector);
  if (!isBetaTestingEnabled) {
    return "light";
  }
  return themeModeSetting?.value ?? "system";
}

/**
 * The same mode with `"system"` resolved against the OS colour scheme, for the places that need a
 * concrete answer rather than a mode to hand to MUI.
 */
export function useEffectiveThemeMode() {
  const mode = useEffectiveColorSchemeMode();
  const systemThemeMode = useSystemThemeMode();
  return mode === "system" ? systemThemeMode : mode;
}